import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { ListFilterRequest } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_PROFILES } = ServerConstants;
const { REQUEST_PROFILES_LIST_ID } = ServiceConstants;

export async function profilesAll(filter: ListFilterRequest) {
  const requestId = REQUEST_PROFILES_LIST_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_PROFILES}?page=${filter.page}&search=${filter.search}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, profilesAll, [filter], requestId);
  }
}